/**
 * We are self hosting third party vendors that are not available in npm to prevent cross-domain attacks (CM)
 **/

// require third party vendors that are not available in npm (CM)

require('./freshwidget');
require('./analytics'); // google analytics (CM)
require('./tableau');

const isNewRelicEnabled = process.env.RELEASE && process.env.PUBLIC_CONFIG.NEW_RELIC_APPLICATION_ID;
if (isNewRelicEnabled) {
  require('./newrelic');
}

// freshdesk initiation
FreshWidget.init('', {
  queryString: '&widgetType=popup&submitThanks=Thank+you+for+your+feedback&responsive=no',
  utf8: '✓',
  widgetType: 'popup',
  buttonType: 'text',
  buttonText: 'Report Issues',
  buttonColor: 'white',
  buttonBg: '#0072bb',
  alignment: '2',
  offset: '300px',
  submitThanks: 'Thank you for your feedback',
  formHeight: '500px',
  responsive: 'yes',
  url: 'https://newvisions.freshdesk.com',
});

// Google Analytics Tracking snippet needed for angulartics package (CM)
(function(i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  (i[r] =
    i[r] ||
    function() {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

//Google Tag Manager snippet for angulartics package
(function(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-P7W6MLN');
